{
  "title": "如何邀請評審",
  "description": "邀請評審加入指定競賽並開始評分。",
  "headings": [
    "你會完成什麼",
    "適用角色",
    "操作前確認",
    "操作路徑",
    "操作步驟",
    "完成後",
    "常見問題"
  ],
  "summary": "完成後，指定評審會收到邀請，並可進入競賽評審流程。",
  "roleNote": "競賽管理員",
  "prerequisites": ["競賽已建立", "已取得評審 Email", "評審階段已設定"],
  "pathLabel": "主辦方後台 → 我的競賽 → 評審邀請與指派 → 邀請管理",
  "steps": [
    {
      "title": "1. 開啟「評審邀請與指派」",
      "description": "進入指定競賽後，點選「評審邀請與指派」，切換到「邀請管理」分頁。"
    },
    {
      "title": "2. 輸入評審 Email",
      "description": "在邀請欄位輸入評審的 Email；若該 Email 尚無帳號，系統會自動建立帳號並寄送臨時密碼。"
    },
    {
      "title": "3. 送出邀請",
      "description": "確認 Email 正確後，點選「發送邀請」。已有帳號的評審登入後會在「總覽」頁看到邀請並自行接受或婉拒；婉拒會在邀請列表顯示「已婉拒」與原因，可再次邀請。"
    }
  ],
  "afterward": [
    "評審出現在邀請列表",
    "邀請狀態顯示「已邀請」",
    "系統寄出邀請通知（新帳號的邀請信會說明臨時密碼期限、逾期可用「忘記密碼」，並提醒邀請信箱即登入帳號，建議使用日常信箱如 Gmail）；寄送成功或失敗會記錄在稽核紀錄（不含 Email 位址），寄信失敗不會使邀請失敗，可稍後使用「重新發送」"
  ],
  "nextSteps": "接著可以前往「作品指派」分頁，指派作品給已邀請的評審。",
  "faq": [
    {
      "q": "評審沒有收到邀請信怎麼辦？",
      "a": "先確認 Email 是否輸入正確、請對方檢查垃圾郵件，再回到「邀請管理」分頁查看邀請狀態，必要時點選重新發送。"
    }
  ]
}
